var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnPen2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0859 2.60156L10.0195 3.66797L7.83203 1.48047L8.89844 0.414062C9.00781 0.304688 9.14453 0.25 9.30859 0.25C9.47266 0.25 9.60938 0.304688 9.71875 0.414062L11.0859 1.78125C11.1953 1.89062 11.25 2.02734 11.25 2.19141C11.25 2.35547 11.1953 2.49219 11.0859 2.60156ZM0.75 8.5625L7.20312 2.10938L9.39062 4.29688L2.9375 10.75H0.75V8.5625Z",
    fill: "#007BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnPen2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-pen2.8ea98231.svg";
export { ForwardRef as ReactComponent };